//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, {
  useState,
  useEffect,
  useContext,
  Fragment,
  useCallback,
} from "react";
import * as moment from "moment";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { toastCss } from "assets/styleJS/global";
import { parseISO } from "date-fns";
import { useHistory } from "react-router";

// custom pages
import Table from "components/Table/Table";
import ManageSignatureAccountsAPI from "apis/manageSignatureAccounts/manageSignatureAccounts";
import ManageServicePlusAccountsAPI from "apis/manageServicePlusAccounts/manageServicePlusAccounts";
import AuditAPI from "apis/audit/audit";
import Context from "context/context";
import searchIcon from "assets/img/Search_Icon.png";
import { Styles } from "./styles";
import useDebounce from "helpers/useDebounce";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";
import Loader from "components/Loader/Loader";
import { ImportDataHeader } from "./Headers/headers";
import { exporDatatHeaders } from "./Headers/headers";

import { CSVLink } from 'react-csv';

// material-ui
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import CircularProgress from "@material-ui/core/CircularProgress";

// material-ui icons
import Grid from "@material-ui/core/Grid";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { blockInvalidChar } from "helpers/blockInvalidChar";
import HistoryIcon from "@material-ui/icons/History";
import { pointsFormat } from "helpers/dataFormat";
const Papa = require("papaparse/papaparse.min.js");

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
        background: "#ededed",
      },
    },
  },
})(TextField);

const IOSSwitch = withStyles((theme) => ({
  root: {
    width: 42,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(16px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#2F7CBD",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#2F7CBD",
      border: "6px solid #2F7CBD",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid gray`,
    backgroundColor: "gray",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}))(({ classes, ...props }) => {
  return (
    <Switch
      focusVisibleClassName={classes.focusVisible}
      disableRipple
      classes={{
        root: classes.root,
        switchBase: classes.switchBase,
        thumb: classes.thumb,
        track: classes.track,
        checked: classes.checked,
      }}
      {...props}
    />
  );
});

export default function ShiptoDetails() {

  const { getAPI, exportAPI,updateServiceAPI,searchAPI } = ManageServicePlusAccountsAPI();
  const { getServiceCustomAuditAPI } = AuditAPI();
  const history = useHistory();

  const { state, dispatch } = useContext(Context);
  const classes = Styles();

  const [data, setData] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  const [minimalDate, setMinimalDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [pointsUpdateObj, setPointsUpdateObj] = useState({
    open: false,
    amount: 0,
    count: 0,
    courtesyPoints: 0,
    points: 0,
    isConfirm: false
  });
  const [updateObj, setUpdateObj] = useState({
    clearSearch: false,
    index: 0,
    obj: {},
    modal: false,
    servicePlusStartDate: moment(new Date()).format("YYYY-MM-DD"),
    servicePlusEndDate: moment(new Date()).format("YYYY-MM-DD"),
    type: "",
  });
  const [updateLoading, setUpdateLoading] = useState(false);
  const [bulkUploadOpen, setBulkUploadOpen] = useState(false);
  const [exportData, setExportData] = useState([]);
  const [exportHeaders, setExportHeaders] = useState([]);
  const [exportFileName, setExportFileName] = useState("");


  const [fileName, setFileName] = useState("");

  // Common State Object
  const [states, setstates] = useState({
    clearSearch: false,
    historyDialog: false,
    historyLoader: false,
    data: []
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;
  let searchBounceValues = useDebounce(() => {
    return searchValue === '' ? '' : searchValue;
  });
  const { clearSearch } = states;
  const { t, i18n } = useTranslation();
  let selectedColumns = ImportDataHeader.map((header) => header.label);
  const getPlanName = (plan) => {
    if (!plan) return "-";
    const index = plan.indexOf("-");
    if (index === -1) {
      return plan.split(" ").slice(0, 2).join(" ");
    }
    return plan.substring(0, index).trim();
  };
 
  let tableHeading = [
    "Member ID",
    "Billto",
    "Shipto",
    "Shipto Name",
    "Service Plus Status",
    "Tier Level",
    // "Start Date",
    // "End Date",
    "Enroll/Cancel Service Plus",
    "History",
  ];

  const handlePagination = (value) => {
    setOffset(value);
  };

  useEffect(() => {
    if (!clearSearch) {
      if (searchBounceValues && searchBounceValues.length > 0) {
        handleSearch();
      }
      else {
        handleGet();
      }
    }
    else {
      setStates({ clearSearch: false });
    }
  }, [searchBounceValues, offset]);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "MANAGE SERVICE PLUS ACCOUNTS"],
    });
  }, []);

  // Get data API
  async function handleGet() {
    try {
      setLoading(true);
      let values;
      values = {
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setMinimalDate(res?.minimaldate)
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // Search data API
  async function handleSearch() {
    try {
      setLoading(true);
      let values;
      values = {
        search: searchValue,
        offset: (offset - 1) * 10,
        limit: 10,
      };

      dispatch({ type: "SET_LOADING", payload: true });
      let res = await searchAPI(values);
      if (res) {
        setData(res.data);
        setCount(res.count);
        setMinimalDate(res?.minimaldate)
        setLoading(false);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (e) {
      console.log({ e });
    }
  }

  // Update signature API
  const handleUpdateSignature = async () => {

    console.log("click")
    toast.dismiss();
    try {
      setUpdateLoading(true);
      let values = {};

      values = {
        id: updateObj?.obj?._id,
        type: updateObj?.type,
      };

      if (updateObj?.type === "MOVE-TO-SERVICEPLUS") {
        values = { ...values, date: moment(updateObj?.servicePlusStartDate) };
      } else {
        values = { ...values, date: moment(updateObj?.servicePlusEndDate) };

      }

      let res = await updateServiceAPI(values);
      if (res && res?.type === "SUCCESS") {
        let msg = "";
        if (updateObj?.type === "MOVE-TO-SERVICEPLUS") {
          msg = "Account moved to Service Plus Successfully";
        }
        if (updateObj?.type === "MOVE-TO-NONSERVICEPLUS") {
          msg = "Account moved to NON-Service Plus Successfully";
        }
        toast.success(msg, { tostId: "signature-update-success" });
        setUpdateObj({
          index: 0,
          obj: {},
          modal: false,
          servicePlusStartDate: moment(new Date()).format("YYYY-MM-DD"),
          servicePlusEndDate: moment(new Date()).format("YYYY-MM-DD"),

          type: "",
        });
        if (offset === 1) {
          handleGet();
        } else {
          setOffset(1);
        }
      }
      setUpdateLoading(false);
    } catch (e) {
      console.log({ e });
    }
  };

  // Get signature history
  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        feature: "manageServicePlusAccounts",
      };
      let res = await getServiceCustomAuditAPI(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };


  const handleExport = async () => {
    let values = {};
    if (searchValue) {
      values = { ...values, searchValue };
    }

    dispatch({ type: "SET_LOADING", payload: true });
    setIsLoading(true);

    let res = await exportAPI(values);
    if (res && res?.type === "ERROR") {
      dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
      setStates({
        pLoading: false,
        eLoading: false,
        errorDialog: true,
        errorCount: res?.count,
      });
    }
    if (res && res.data) {
      dispatch({ type: "SET_REPORT_RES_COUNT", payload: 0 });
      setExportData(res.data.map(obj => {
        return {
          ...obj,
          service_plus_flag: obj?.service_plus_flag ? obj?.service_plus_end_date ? 'Cancelling' : 'Active' : 'Not Active'
        }
      }));
      setExportFileName('SERVICE_PLUS_ACCOUNTS')
      setExportHeaders(exporDatatHeaders)
      dispatch({ type: "SET_LOADING", payload: false });
      setIsLoading(false);
      setStates({
        response: true,
        pLoading: false,
        eLoading: false,
      });
      if (res.data.length === 0) {
        toast.success(t("No Data Found"), { toastId: "no-report-date" });
        return false;
      }
      return true;
    }
  };
  const handleExportimport = async () => {
    setExportData([])
    setExportHeaders(ImportDataHeader)
    setExportFileName('Signature_Offboarding')
    return true;
  };

  function selectedColumnFun() {
    {
      setStates({ data: [] });
      let data = [];
      ImportDataHeader.map((header, i) => {
        if (selectedColumns?.includes(header.label)) {
          data = [...data, header.key];
          return;
        }
      });
      setStates({ selectedFields: data });
    }
  }

  function handleChange(event) {
    selectedColumnFun();
    importCSV(event.target.files[0]);
  }

  function importCSV(csvFile) {
    Papa.parse(csvFile, {
      complete: updateData,
      header: true,
    });
    setFileName(csvFile.name)
  }

  function updateData(result) {
    var data = result.data;
    preparePayload(data);
  }

  function preparePayload(data) {
    const payload = [];
    for (let value of data) {
      if (
        JSON.stringify(selectedColumns) === JSON.stringify(Object.keys(value))
      ) {
        let achData = {};
        ImportDataHeader.forEach((header) => {
          achData[header.key] = value[header.label];
        });
        if (!moment(achData.service_plus_end_date, 'MM/DD/YYYY').isValid()) {
          setFileName("");
          return toast.error(`Please Enter valid dateformat for ${achData?.customer_account_number} shipto`, {
            ...toastCss,
            autoClose: 5000,
          })
        }
        payload.push(achData);
      }
    };
    if (payload.length === 0) {
      setFileName("");
      toast.error(`*${t("Please import csv file in given order")
        }`, {
        ...toastCss,
        autoClose: 5000,
      });
      document.getElementById("demo").value = null;
      return;
    }
    setStates({ data: payload });
  }

  // const handleUploadCSV = async () => {
  //   try {
  //     if (states.data.length == 0) {
  //       return toast.error(`*${t("Please import csv file in given order")
  //         }`, {
  //         ...toastCss,
  //         autoClose: 5000,
  //       });
  //     }
  //     let values = {
  //       data: states.data
  //     };
  //     setUpdateLoading(true);
  //     let res = await bulkSignatureUnEnroll(values);

  //     setUpdateLoading(false);
  //     if (res.type === "success" && res.valid) {
  //       // setStates({ dialog: false });
  //       return history.push("/dashboard/signature-status", {
  //         data: {

  //           successCount: res.successCount  // Adding successData
  //         },
  //         type: i18n.language == 'fr' ? res.french_message : res.message

  //       });
  //     } else if (res.type === "success" && res.invalid) {
  //       let headers = [...ImportDataHeader, {

  //         label: "Status",
  //         key: "status"

  //       }
  //       ]

  //       return history.push("/dashboard/signature-status", {
  //         obj: {
  //           data: {
  //             invalidData: res.invalidData,
  //             successData: res.successData,  // Adding successData
  //           },
  //           uploadedCount: res.uploadedCount,
  //           invalidCount: res.invalidCount,
  //           successCount: res.successCount,
  //           ImportDataHeader,
  //           headers
  //         }
  //       });
  //     }
  //   } catch (err) {
  //     setStates({ loading: false });
  //     console.log(err);
  //   }
  // };

  // Function to get the larger date
  const getLargerDate = (date1, date2) => {
    // Parse the dates using moment
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);

    // Compare the dates and return the larger date
    return momentDate1.isAfter(momentDate2) ? momentDate1 : momentDate2;
  };

  return (
    <Fragment>
      <Grid xs={12} sm={12} lg={12} className={classes.topGrid}>
        <CssTextField
          id="enterPassword"
          placeholder={t("Search for Billto or Shipto")}
          onKeyDown={blockInvalidChar}
          type={"number"}
              onWheel={(e) => e.target.blur()}
          variant="outlined"
          autoComplete="off"
          className={classes.searchInput}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {searchValue.length > 0 ? (
                  <CloseOutlinedIcon
                    className={classes.searchInputIcon}
                    onClick={() => {
                      setStates({ clearSearch: true });
                      setSearchValue("");
                      if (offset === 1) {
                        handleGet();
                      }
                      else {
                        setOffset(1);
                      }
                    }}
                  />
                ) : (
                  <img
                    src={searchIcon}
                    alt=""
                    width="20px"
                    className={classes.searchInputIcon}
                  />
                )}
              </InputAdornment>
            ),
          }}
          value={searchValue}
          onChange={(e) => {
            e.target.value.replace(/\s+/g, "").length == 0
              ? setSearchValue("")
              : setSearchValue(e.target.value);
            if (e.target.value.length == 0) {
              handleGet();
            }
          }}
          onClick={() => {
            setOffset(1);
          }}
        />
        <div>
          {/* <button className={classes.blukUploadBtn} onClick={() => setBulkUploadOpen(true)}>Signature Offboarding</button> */}
          <button
            className={classes.exportBtn}
            onClick={async () => {
              setStates({ response: false, data: [], eLoading: true });
              let res = await handleExport();
              if (res) {
                let data = [];
                document.getElementById("csv").click();
              }
            }}
            disabled={states.eLoading || states.pLoading}
          >
            {states.eLoading ? (
              // <React.Fragment>
              //   <CircularProgress
              //     style={{ height: 25, width: 25, color: "#fff" }}
              //     variant="determinate"
              //     value={state.reportResCount}
              //   />
              //   &nbsp;
              //   <span >
              //     {state.reportResCount == 0 ?
              //       <div class="snippet">
              //         <div class="stage">
              //           <div class="dot-typing-e"></div>
              //         </div>
              //       </div>
              //       : `${state.reportResCount}%`}
              //   </span>
              // </React.Fragment>
              'Loading...'
            ) : (
              ` Export `
            )}
          </button>
        </div>
      </Grid>
      <div style={{ marginTop: 20 }}>
        {!loading ? (
          <Table
            headings={tableHeading.map((i) => {
              return <div key={t(i)}>{t(i)}</div>;
            })}
            data={
              data &&
              data.length > 0 &&
              data.map((d, i) => [
                d?.loyalty_id,
                d?.customer_billto_account_number,
                d?.customer_account_number,
                d?.customer_name,
                
                d?.service_plus_flag ?
                  d?.service_plus_end_date ? (
                    <span className={classes.redBtn}>{"Cancelling"}</span>
                  ) :
                    (
                      <span className={classes.greenBtn}>{"Active "}</span>
                    ) : (
                      <span className={classes.blackBtn} style={{ whiteSpace: 'nowrap' }}>Not Active</span>

                  ),
                  getPlanName(d?.tier_service_agreement),                  
                // d?.signature_start_date
                //   ? moment(d?.signature_start_date).format("MM/DD/YYYY")
                //   : "-",
                // d?.signature_end_date
                //   ? moment(d?.signature_end_date).format("MM/DD/YYYY")
                //   : "-",
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={d?.service_plus_flag}
                      // disabled={!access['editAccess'][state.userInfo?.role]['member-details']}
                      onChange={() => {
                        // if(access['editAccess'][state.userInfo?.role]['member-details'] ){
                        if (d?.service_plus_flag) {
                          setUpdateObj({
                            ...updateObj,
                            index: i,
                            obj: d,
                            modal: true,
                            type: "MOVE-TO-NONSERVICEPLUS",
                          });
                        } else {
                          setUpdateObj({
                            ...updateObj,
                            index: i,
                            obj: d,
                            modal: true,
                            type: "MOVE-TO-SERVICEPLUS",
                          });
                        }
                        setData([
                          ...data.slice(0, i),
                          { ...data[i], checked: !d?.checked },
                          ...data.slice(i + 1),
                        ]);
                        return;
                        //   }  else{
                        //     toast.error(state.userInfo?.editAccess)
                        //   return;
                        // }
                      }}
                      name=""
                    />
                  }
                />,
                state?.userInfo?.auditAccess && (
                  <HistoryIcon
                    style={{ cursor: "pointer", verticalAlign: "middle" }}
                    onClick={() => {
                      setStates({
                        historyDialog: true,
                        historyLoader: true,
                      });
                      handleGetHistoryData(d?._id);
                    }}
                  />
                ),
              ])
            }
            offset={offset}
            count={
              (count / 10) % 1 == 0
                ? Math.floor(count / 10)
                : Math.floor(count / 10 + 1)
            }
            handlePagination={handlePagination}
          />
        ) : (
          <div
            style={{
              height: "25vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>{t("Loading...")}</h2>
          </div>
        )}
      </div>
      {/* Signature handling dialog */}
      <Dialog
        maxWidth={"md"}
        aria-labelledby="simple-dialog-title"
        open={updateObj.modal}
        style={{ fontFamily: "Segoe-ui" }}
      >
        <div className={classes.dialogParentDiv}>
          {updateObj?.type === "MOVE-TO-SERVICEPLUS" && <div className={classes.parentText}>{t("Service Plus Enrollment")}</div>}
          {updateObj?.type === "MOVE-TO-NONSERVICEPLUS" && <div className={classes.parentText}>{t("Confirm Service Plus Cancellation")}</div>}

          <div className={classes.parentText2}>
            &nbsp;&nbsp;&nbsp;
            {updateObj?.type === "MOVE-TO-SERVICEPLUS" && (
              <Fragment>
                <span>
                  {t(
                    `Select the Member’s Service Plus Start Date`
                  )}
                </span>
                <br />

                {/* <span className={classes.parentText3Note}>
                  {`${t("Shipto")} : ${updateObj?.obj?.customer_account_number}`}
                </span> */}
              </Fragment>
            )}
            {updateObj?.type === "MOVE-TO-NONSERVICEPLUS" && (
              <span>
                {t(
                  "Schedule or adjust a Service Plus end date up to a day before the set cancellation date."
                )}
              </span>
            )}
          </div>
          <br />
          <Fragment>
            {updateObj?.type === "MOVE-TO-SERVICEPLUS" && (
              <Fragment>
                {/* <div className={classes.subParentHeader}>
                  {t("Select the Signature Start Date")}&nbsp;
                  <span style={{ color: "red" }}>*</span>
                </div> */}
                <div className={classes.subParentBody}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format={"MM/dd/yyyy"}
                      margin="normal"
                      id="deactive-date"
                      className={classes.dateInput}
                      minDate={new Date()}
                      //  minDate={updateObj?.obj?.service_plus_end_date ? moment(updateObj?.obj?.service_plus_end_date).add(1, 'days') : getLargerDate(moment().subtract(minimalDate, 'days'), moment(updateObj?.obj?.loyalty_start_date))}
                      value={parseISO(updateObj?.servicePlusStartDate)}
                      onChange={(date) => {
                        let d = moment(date).format("YYYY-MM-DD");
                        setUpdateObj({
                          ...updateObj,
                          servicePlusStartDate: d,
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </Fragment>
            )}
            {updateObj?.type === "MOVE-TO-NONSERVICEPLUS" && (
              <Fragment>
                <div className={classes.subParentHeader}>
                  {updateObj?.obj?.service_plus_end_date ? t("Edit the Service Plus End Date") : t("Service Plus End Date")}&nbsp;
                  <span style={{ color: "red" }}>*</span>
                </div>
                <div className={classes.subParentBody}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      disableToolbar
                      inputVariant="outlined"
                      format={"MM/dd/yyyy"}
                      margin="normal"
                      id="deactive-date"
                      className={classes.dateInput}
                      // maxDate={moment()}
                      //  minDate={moment()}
                      minDate={new Date()}
                      value={parseISO(updateObj?.servicePlusEndDate)}
                      onChange={(date) => {
                        let d = moment(date).format("YYYY-MM-DD");
                        setUpdateObj({
                          ...updateObj,
                          servicePlusEndDate: d,
                        });
                      }}
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      autoOk
                    />
                  </MuiPickersUtilsProvider>
                </div>
              </Fragment>
            )}
          </Fragment>
          {/* {updateObj?.obj?.signature_end_date && <div style={{ textAlign: 'center' }}>or</div>} */}
          {(updateObj?.obj?.service_plus_end_date && updateObj?.obj?.service_plus_flag) &&
            <div style={{ textDecoration: 'underline', color: 'blue', textAlign: 'center', cursor: 'pointer', fontSize: 17, }}
              onClick={async () => {
                try {
                  let res = await updateServiceAPI({ type: "CONTINUE-TO-SERVICEPLUS", id: updateObj?.obj?._id })
                  if (res && res?.type === "SUCCESS") {
                    toast.success("Account moved to service Plus Successfully", { tostId: "signature-update-success" });
                    setUpdateObj({ ...updateObj, modal: false })
                    handleGet();
                  }
                } catch {
                  toast.error("Something went wrong", { tostId: "signature-update-failed" });
                }
              }}>
              Remove Signature End Date
            </div>
          }
          <br />
          {updateObj?.type === "MOVE-TO-SERVICEPLUS" &&
            <span className={classes.parentText2Note}>
              {t(
                "Note: Service Plus benefits will be awarded according to the start date that is selected."
              )}
            </span>
          }
          <br />
          <br />
          <Grid container spacing={0}>
            {!updateLoading ? (
              <Fragment>
                {" "}
                <Grid item xs={6}>
                  <Button
                    className={classes.cancelBtn}
                    disabled={loading}
                    onClick={() => {
                      setData([
                        ...data.slice(0, updateObj?.index),
                        {
                          ...data[updateObj?.index],
                          checked: !data[updateObj?.index]?.checked,
                        },
                        ...data.slice(updateObj?.index + 1),
                      ]);
                      setUpdateObj({
                        index: 0,
                        obj: {},
                        modal: false,
                        servicePlusStartDate: moment(new Date()).format(
                          "YYYY-MM-DD"
                        ),
                        servicePlusEndDate: moment(new Date()).format(
                          "YYYY-MM-DD"
                        ),
                        type: "",
                      });
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </Grid>
                <Grid item xs={6} className={classes.proceedBtnGrid}>
                  <Button
                    className={classes.proceedBtn}
                    disabled={loading}
                    onClick={() => {
                      if (updateObj?.type === "MOVE-TO-SERVICEPLUS") {

                        // if (moment(updateObj?.servicePlusStartDate).isBefore(moment().subtract(minimalDate, 'days').format("YYYY-MM-DD"))) {
                        //   toast.dismiss();
                        //   return toast.error("Date should not be before minimal date", {
                        //     toastId: "invalid-signature-startdate-error",
                        //   });
                        // }
                        // if (moment(updateObj?.servicePlusStartDate).isAfter(moment().format("YYYY-MM-DD"))) {
                        //   toast.dismiss();
                        //   return toast.error("Invalid Start Date", {
                        //     toastId: "invalid-signature-startdate-error",
                        //   });
                        // }
                        if (moment(updateObj?.servicePlusStartDate).isBefore(moment(updateObj?.obj?.loyalty_start_date).format("YYYY-MM-DD"))) {
                          toast.dismiss();
                          return toast.error("Date should not be before minimal date", {
                            toastId: "invalid-signature-startdate-error",
                          });
                        }
                        if (updateObj?.obj?.service_plus_end_date && moment(updateObj?.servicePlusStartDate).isBefore(moment(updateObj?.obj?.service_plus_end_date).add(1, 'days').format("YYYY-MM-DD"))) {
                          toast.dismiss();
                          return toast.error("Date should not be before minimal date", {
                            toastId: "invalid-signature-startdate-error",
                          });
                        }
                        if (updateObj?.servicePlusStartDate === "Invalid date") {
                          toast.dismiss();
                          return toast.error("Invalid Start Date", {
                            toastId: "invalid-signature-startdate-error",
                          });
                        }
                        // if (moment(updateObj.servicePlusStartDate).isBefore(moment().format('YYYY-MM-DD'))) {
                        //   handleUpdateSignature()
                        // }
                       handleUpdateSignature()
                      }
                      if (updateObj?.type === "MOVE-TO-NONSERVICEPLUS") {
                        if (moment(updateObj?.servicePlusEndDate).isBefore(moment(new Date()).format("YYYY-MM-DD"))) {
                          toast.dismiss();
                          return toast.error("Date should not be before minimal date", {
                            toastId: "invalid-signature-startdate-error",
                          });
                        }
                        handleUpdateSignature();
                      }
                      // handleUpdateSignature();
                    }}
                  >
                    {t("Update")}
                  </Button>
                </Grid>
              </Fragment>
            ) : (
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>
            )}
          </Grid>
        </div>
      </Dialog>
      {/* <Dialog
        aria-labelledby="simple-dialog-title"
        open={pointsUpdateObj?.open}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={'md'}
      >
        <div className={classes.dialogParentDiv} style={{ margin: 20, background: "#ddd" }}>
          <div className={classes.parentText} style={{ textAlign: 'center' }}>{`${t("Confirm")} Additional Signature Points`}</div>

          <div className={classes.tdiv}>
            <div className={classes.parentText3}>
              {`Shipto ID : ${updateObj?.obj?.customer_account_number}`}
            </div>
            <table style={{ margin: 20 }}>
              <tr>
                <td className={classes.td}>Total Transaction Count</td>
                <td className={classes.td}><strong>{pointsUpdateObj?.count}</strong></td>
              </tr>
              <tr>
                <td className={classes.td}>Total Eligible Purchase Amt</td>
                <td className={classes.td}><strong>${pointsUpdateObj?.amount}</strong></td>
              </tr>
              <tr>
                <td className={classes.td}>Total Points Already Awarded</td>
                <td className={classes.td}><strong>{pointsUpdateObj?.points}</strong></td>
              </tr>
            
              <tr>
                <td className={classes.td}>Total Additional Points</td>
                <td className={classes.td}><strong>{pointsUpdateObj?.courtesyPoints}</strong></td>
              </tr>
            </table>

          </div>

       
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: "20px 20px 0px 20px" }}>
            {!updateLoading ? (
              <>
                <Button className={classes.cancelBtn} style={{ fontSize: 12, borderWidth: 1, borderRadius: 5 }} onClick={() => setPointsUpdateObj({ ...pointsUpdateObj, open: false, isConfirm: false })}>Cancel</Button>
                <Button className={classes.proceedBtn} style={{ fontSize: 12, borderRadius: 5 }} onClick={async () => {
          
                  await handleUpdateSignature()
                  setPointsUpdateObj({ ...pointsUpdateObj, open: false })
                }}>Proceed</Button>
              </>
            ) :
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>}
          </div>
        </div>
      </Dialog> */}
      {/* Audit Logs Dialog */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            History{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Setting",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  // d?.column_name,
                  d?.column_name,
                  `"${!d?.old_value ? 'not set' : (moment(d?.old_value, 'YYYY-MM-DD', true).isValid() ? moment(d?.old_value).format("YYYY-MM-DD") : d?.old_value)}" 
                    changed to 
                  "${!d?.new_value ? 'not set' : (moment(d?.new_value, 'YYYY-MM-DD', true).isValid() ? moment(d?.new_value).format("YYYY-MM-DD") : d?.new_value)}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
      {/* <Dialog
        aria-labelledby="simple-dialog-title"
        open={bulkUploadOpen}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={'md'}
      >
        <div className={classes.dialogParentDiv} style={{ margin: 20, background: "#ddd" }}>
          <Grid
            item
            xs={12}
            style={{
              textAlign: "center",
              marginTop: 10,
              marginBottom: 10,
              marginLeft: 40,
            }}
          >
            <h2>Signature Offboarding</h2>
            <input
              id="demo"
              type="file"
              accept=".csv"
              placeholder={t("import csv")}
              style={{ color: "transparent", width: "45%" }}
              onChange={(e) => {
                if (!state?.userInfo?.editAction) {
                  toast.error(state.userInfo?.editAccess)
                  return;
                }
                if (state?.userInfo?.editAction) {
                  // console.log({e});
                  handleChange(e)
                  return;
                }
                else {
                  toast.error(state.userInfo?.editAccess)
                  return;
                }
              }}
              disabled={!state?.userInfo?.editAction}
            />
            {fileName && <div>{fileName}</div>}
            <div style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={async () => {
              let res = await handleExportimport();
              if (res) {
                document.getElementById("csv").click();
              }
            }}>click here to download sample file</div>
          </Grid>
          <div style={{ display: 'flex', justifyContent: 'space-between', margin: "20px 20px 0px 20px" }}>
            {!updateLoading ? (
              <>
                <Button className={classes.cancelBtn} style={{ fontSize: 12, borderWidth: 1, borderRadius: 5 }}
                  onClick={() => {
                    setBulkUploadOpen(false);
                    setFileName("");
                  }}>
                  Cancel
                </Button>
                <Button className={classes.proceedBtn} style={{ fontSize: 12, borderRadius: 5 }} onClick={async () => {
                  await handleUploadCSV()
                }}>Proceed</Button>
              </>
            ) :
              <Grid item xs={12} className={classes.updateDialogLoader}>
                <CircularProgress />
              </Grid>}
          </div>
        </div>
      </Dialog> */}
      <CSVLink
        id='csv'
        data={exportData}
        headers={exportHeaders}
        filename={exportFileName +
          ' ' +
          moment(new Date()).format('MM-DD-YYYY,h:mm A') +
          '.csv'
        }
        className={classes.CSVlink}
      />
    </Fragment >
  );
}
